export const playRateList = [
  { value: '0.75', text: '0.75x' },
  { value: '1.0', text: '1.0x' },
  { value: '1.25', text: '1.25x' },
  { value: '1.5', text: '1.5x' },
  { value: '2.0', text: '2.0x' },
];
